import React from 'react';
import { Link } from 'react-router-dom';
import styled from 'styled-components';
import { motion } from 'framer-motion';

const Card = styled(motion.div)`
  background: white;
  border-radius: ${props => props.theme.borderRadius.large};
  overflow: hidden;
  box-shadow: ${props => props.theme.shadows.medium};

  display: flex;
  flex-direction: column;
  height: 100%;
`;

const Image = styled.img`
  width: 100%;
  height: 260px;
  object-fit: cover;
`;

const Content = styled.div`
  padding: 2rem;

  display: flex;
  flex-direction: column;
  flex: 1;
`;

const Title = styled.h3`
  font-size: 1.8rem;
  margin-bottom: 1rem;
  color: ${props => props.theme.colors.secondary};
`;

const Description = styled.p`
  color: ${props => props.theme.colors.gray};
  line-height: 1.6;
  margin-bottom: 1.5rem;
`;

const Features = styled.ul`
  list-style: none;
  padding: 0;
  margin: 0 0 2rem 0;

  li {
    margin-bottom: 0.6rem;
    color: ${props => props.theme.colors.gray};
  }
`;

const ButtonWrapper = styled.div`
  margin-top: auto;
`;

const Button = styled(Link)`
  display: inline-block;
  background: ${props => props.theme.colors.primary};
  color: white;
  padding: 0.9rem 1.5rem;
  border-radius: ${props => props.theme.borderRadius.medium};
  text-decoration: none;
  font-weight: 600;
  transition: 0.2s;

  &:hover {
    opacity: 0.9;
  }
`;

const ApartmentCard = ({ apartment, index }) => {

  return (
    <Card
      initial={{ opacity: 0, y: 40 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.4, delay: index * 0.2 }}
    >

      <Image src={apartment.images[0]} alt={apartment.name} />

      <Content>

        <Title>{apartment.name}</Title>

        <Description>
          {apartment.description}
        </Description>

        <Features>

          {apartment.features.map((feature, i) => (
            <li key={i}>✓ {feature}</li>
          ))}

        </Features>

        <ButtonWrapper>

          <Button to={`/apartment/${apartment.id}`}>
            ZOBACZ SZCZEGÓŁY
          </Button>

        </ButtonWrapper>

      </Content>

    </Card>
  );

};

export default ApartmentCard;